import React from 'react';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { Box } from '@mui/material';
import { StatusTag } from '@chr/eds-react';
import { getRiskLevel } from '../../utilities/riskLevels';
import { RiskLevel } from '../../apis/dtos';

const urgentStyle = {
  '.MuiChip-label, .MuiChip-icon': {
    color: '#440082 !important',
  },
};

export interface RiskLevelComponentProps {
  riskLevel?: RiskLevel;
  size?: 'small' | 'medium' | 'large';
  density: 'default' | 'compact' | 'light';
}

const RiskLevelComponent = ({ riskLevel, size, density }: RiskLevelComponentProps) => {
  const translate = useTranslation();
  let statusSize = size;

  if (!riskLevel) {
    return null;
  }

  // check if riskLevel is an enum in RiskLevel, as invalid values can be passed in.
  if (!Object.values(RiskLevel).includes(riskLevel)) {
    return null;
  }

  if (!size) {
    statusSize = 'small';
  }

  const {
    label,
    style: { severity }
  } = getRiskLevel(riskLevel);

  return (
    <Box
      sx={{
        ...(severity === 'urgent' ? urgentStyle : {}),
      }}
      data-testid="risk-container"
    >
      <StatusTag
        label={translate(label)}
        severity={severity}
        size={statusSize}
        density={density}
        icon={true}
      />
    </Box>
  );
};

export default RiskLevelComponent;
